export const VERIFICATION_METHOD_TOOLTIPS = {
  HEURISTIC: {
    TITLE: 'Heuristic',
    CONTENT:
      'Indicates a component that was identified through signature-based means such as string searches, regular expression matches, and other proprietary heuristic methods.'
  },

  CRYPTOGRAPHIC_HASH: {
    TITLE: 'Cryptographic Hash',
    CONTENT: 'Indicates a component that was identified through a variety of hash-based mechanisms.'
  },

  PACKAGE_MANAGER: {
    TITLE: 'Package Manager',
    CONTENT: 'Indicates a component that was identified through parsing package manifest information.'
  },

  FUNCTION_HASHING: {
    TITLE: 'Function Hashing',
    CONTENT:
      'Components are broken down into their individual functions. These functions are hashed and then compared using machine learning to a known dataset containing billions of function hashes generated from common open source software repositories.'
  },

  SYMBOL_INDEX: {
    TITLE: 'Symbol Index (SymIndex)',
    CONTENT:
      'Uses binary analysis to extract symbol names from ELF files. These symbols are then compared using machine learning to the symbols extracted from the source code of common open source software repositories, returning likely matches.'
  },

  MACHINE_LEARNING: {
    TITLE: 'Machine Learning',
    CONTENT: 'Advanced verification using Function Hashing and Symbol Index (SymIndex) methods powered by machine learning algorithms.'
  },

  USER_MODIFIED: {
    TITLE: 'User Modified',
    CONTENT: 'The user has modified this component and thus verified via them.'
  }
};

export const { HEURISTIC, CRYPTOGRAPHIC_HASH, PACKAGE_MANAGER, FUNCTION_HASHING, SYMBOL_INDEX, MACHINE_LEARNING, USER_MODIFIED } =
  VERIFICATION_METHOD_TOOLTIPS;
